export default [
  {
    id: 1,
    key: 'paperUseAmount',
    name: '账面消耗金额',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      }, {
        label: '>',
        value: '>'
      }, {
        label: '<=',
        value: '<='
      }, {
        label: '<',
        value: '<'
      }
    ],
    unit: '元',
    fixed: true
  },
  {
    id: 2,
    key: 'amount',
    name: '实际消耗金额',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '元',
    fixed: true
  },
  {
    id: 3,
    key: 'createTime',
    name: '新建时间',
    value: '',
    field_type: 'string',
    expression: '<=',
    equalenums: [{
      label: '<=',
      value: '<='
    }],
    unit: '天',
    fixed: true
  },
  {
    id: 4,
    key: 'clickRate',
    name: '点击率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 5,
    key: 'downNum',
    name: '激活数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '个',
    fixed: false
  },
  {
    id: 6,
    key: 'createRoleNum',
    name: '创角数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '个',
    fixed: false
  },
  {
    id: 7,
    key: 'activeRate',
    name: '转化率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 8,
    key: 'newUserNum',
    name: '注册数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '个',
    fixed: false
  },
  {
    id: 9,
    key: 'createRoleCost',
    name: '创角成本',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '元',
    fixed: true
  },
  {
    id: 10,
    key: 'activeCost',
    name: '激活成本',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '元',
    fixed: true
  },
  {
    id: 11,
    key: 'payActiveDeviceNum',
    name: '新增付费设备数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '台',
    fixed: false
  },
  {
    id: 12,
    key: 'payRoleUserNum',
    name: '新增付费创角数',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '个',
    fixed: false
  },
  {
    id: 13,
    key: 'payRoleUserRate',
    name: '新创角付费率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 14,
    key: 'payActiveDeviceNumRate',
    name: '新设备付费率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 15,
    key: 'newRoleRate',
    name: '新创角回款率',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true
  },
  {
    id: 16,
    key: 'oneDayRoi',
    name: '首日ROI',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true,
    precision: 4
  },
  {
    id: 17,
    key: 'threeDayRoi',
    name: '3日ROI',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true,
    precision: 4
  },
  {
    id: 18,
    key: 'fiveDayRoi',
    name: '5日ROI',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [{
      label: '>=',
      value: '>='
    }, {
      label: '>',
      value: '>'
    }, {
      label: '<=',
      value: '<='
    }, {
      label: '<',
      value: '<'
    }],
    unit: '%',
    fixed: true,
    precision: 4
  }
]
